import { takeLatest, call, takeEvery, put } from "redux-saga/effects";
import { Actions } from "../constants/actionTypes";
import {
  fetchAllSites,
  apiSelectedSite,
  apiAlertDetail,
  apiIsValidSiteName,
  apiLbName,
  apiRemoveSite,
  apiGetSiteImages,
  apiDelImage,
  apiWordpressVersionUpdate,
  apiGraphDetails,
  apiSiteOverview,
  apiTopSites,
  apiSitesList,
  apiCreateStagingEnvironment,
  apiDeleteStagingEnvironment,
  apiStagingToggle,
  submitMigrateDetails,
  apiStagingDomainList,
  executeCommand,
  apiStagingRemainTs,
  isMigrationProgress,
  autoLogin,
  apiFetchPlanOvergauge,
  apiDownloadInstanceKey,
  apiGetLightSailPassword,
  apiInstallDomain,
  apiDedicatedRestore,
  apiDedicatedOnDemandBackup,
  apiGetDedicatedStorage,
  apidedicatedPhpCreds,
} from "../Services/sites/sitesAPI/sitesAPI";
import {
  apiFetchSitesRestores,
  apiGetBackup,
  apiGetOndemandBackup,
  apilabelName,
  apiSiteBackupDownload,
  apiSiteRestore,
  apiTagName,
  apiGetEbsBackup,
  apiEbsSiteRestore,
  apiEbsCreateBackup,
} from "../Services/sites/backupsAPI/bkpRstrAPI";
import {
  apiCacheInvalidation,
  apiChangedWpCache,
  apiChangedWpDebug,
  apiDeleteSftpUser,
  apiSftpUserCreate,
  apiSftpUserList,
  apiEbsSftpDetails,
  apiUpdateWaf,
} from "../Services/sites/devtoolsAPI/devtoolAPI";
import {
  apiDeleteSiteFiles,
  apiDownloadSiteFiles,
  apiDownloadSiteFolder,
  apiSiteFiles,
  apiUploadObject,
} from "../Services/sites/fileExplorerAPI/fileAPI";
import {
  apiCheckDnsStatus,
  apiEbsSiteDomains,
  apiMakeTempDomainLive,
  apiNewDomain,
  apiRemoveDomain,
  apiRoconSslhandler,
  apiSitesDomainSslStatus,
  apiSslStatus,
  fetchS3PresignedUrl,
} from "../Services/sites/domainsAPI/domainAPI";

export function* getAllSites() {
  yield takeLatest([Actions.API_ALL_SITES], fetchAllSites);
}

export function* getSelectedSite() {
  yield takeLatest([Actions.API_GET_SELECTED_SITE_DETAILS], apiSelectedSite);
}

export function* siteRestores() {
  yield takeLatest([Actions.API_GET_SITES_RESTORES], fetchSitesRestores);
}

function* fetchSitesRestores(action) {
  const result = yield call(apiFetchSitesRestores, action.data);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    // Toast("Api failed", "Failed to fetch restores of site", "danger");
    action.meta?.onError();
  }
}

export function* apiGetBackups() {
  yield takeLatest([Actions.API_GET_BACKUPS_DETAILS], getbackups);
}

function* getbackups(action) {
  const result = yield call(apiGetBackup, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    // Toast("Api failed", "Failed to upload file", "danger");
    action.meta?.onError();
  }
}

export function* apiGetOndemandBackups() {
  yield takeLatest([Actions.API_CREATE_ON_DEMAND], onDemandBakup);
}

function* onDemandBakup(action) {
  const result = yield call(apiGetOndemandBackup, action);
  if (result.isApiSuccessful) {
    // Toast("Success!!", "On Demand Backup successfully Created", "success");
    action.meta?.onSuccess();
  } else {
    // Toast("Api failed", "Failed On Demand Backups", "danger");
    action.meta?.onError();
  }
}

export function* apiUpdateWAF() {
  yield takeLatest([Actions.API_WAF], wafStatus);
}

function* wafStatus(action) {
  const result = yield call(apiUpdateWaf, action);
}

export function* createSftpUser() {
  yield takeLatest([Actions.API_CREATE_SFTP_USER], sftpUserCreate);
}

function* sftpUserCreate(action) {
  const result = yield call(apiSftpUserCreate, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

// EBS (v2) sites: SFTP details (the API function calls the meta callbacks)
export function* ebsSftpDetails() {
  yield takeLatest([Actions.API_EBS_SFTP_DETAILS], apiEbsSftpDetails);
}

export function* apiAlertDetails() {
  yield takeLatest([Actions.API_GET_ALERTS], alertDetails);
}

function* alertDetails(action) {
  const result = yield call(apiAlertDetail, action);
}

export function* getSelectedSiteFiles() {
  yield takeLatest([Actions.API_GET_SITE_FILES], fetchSiteFiles);
}

function* fetchSiteFiles(action) {
  const result = yield call(apiSiteFiles, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
  return result;
}

export function* deleteSelectedSiteFile() {
  yield takeLatest([Actions.API_DELETE_SITE_FILE], deleteSiteFiles);
}

function* deleteSiteFiles(action) {
  const result = yield call(apiDeleteSiteFiles, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
  return result;
}

export function* listSftpUser() {
  yield takeLatest([Actions.API_SFTP_USER_LIST], sftpUserList);
}

function* sftpUserList(action) {
  const result = yield call(apiSftpUserList, action);
  if (result.isApiSuccessful) {
  } else {
    action.meta?.onError();
  }
}

export function* setDomain() {
  yield takeLatest(Actions.API_CREATE_DOMAIN, setAddedDomain);
}

// apiNewDomain calls meta.onSuccess/onError itself; calling them here too made the page
// navigate and refetch twice per added domain
function* setAddedDomain(action) {
  return yield call(apiNewDomain, action);
}

// EBS (v2) sites: custom domains with their ACM validation record and CloudFront target
// (the API function calls the meta callbacks)
export function* ebsSiteDomains() {
  yield takeLatest([Actions.API_EBS_SITE_DOMAINS], apiEbsSiteDomains);
}

export function* isValidSiteName() {
  yield takeLatest([Actions.API_IS_VALID_SITE], fetchIsValidSiteName);
}

function* fetchIsValidSiteName(action) {
  const result = yield call(apiIsValidSiteName, action.siteName, action.isDedicated);
  if (result.isApiSuccessful) {
    if (result.data !== null) {
      result.data === true ? action.meta.onSuccess() : action.meta.onError();
    } else {
      // Toast("Api failed", "Is valid siteName could not be fetched", "danger");
      action.meta.onError();
    }
  } else {
    // Toast("Api failed", "Is valid siteName could not be fetched", "danger");
    action.meta.onError();
  }
}

export function* getLbName() {
  yield takeEvery([Actions.API_SITES_LB_ARN], fetchLbName);
}

function* fetchLbName(action) {
  const result = yield call(apiLbName, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess(result.data);
  } else {
    action.meta?.onError();
  }
  return result;
}

export function* setWpCache() {
  yield takeLatest([Actions.API_WP_CACHE], setChangedWpCache);
}

function* setChangedWpCache(action) {
  const result = yield call(apiChangedWpCache, action);
  return result;
}

export function* setWpDebug() {
  yield takeLatest([Actions.API_WP_DEBUG], setChangedWpDebug);
}

function* setChangedWpDebug(action) {
  const result = yield call(apiChangedWpDebug, action);
  return result;
}

export function* deleteSite() {
  yield takeLatest([Actions.API_DELETE_SITE], removeSite);
}

function* removeSite(action) {
  const result = yield call(apiRemoveSite, action);
  if (result.isApiSuccessful) {
    action.meta.onSuccess(result.data);
  } else {
    action.meta.onError(result.data);
  }
  return result;
}

export function* setSiteRestore() {
  yield takeLatest([Actions.API_SITE_RESTORE_BACKUP], postSiteRestore);
}

function* postSiteRestore(action) {
  const result = yield call(apiSiteRestore, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
  return result;
}

export function* getEbsBackups() {
  yield takeLatest([Actions.API_GET_EBS_BACKUPS_DETAILS], getEbsBackupsList);
}

function* getEbsBackupsList(action) {
  const result = yield call(apiGetEbsBackup, action);
  if (result?.isApiSuccessful) {
    action.meta?.onSuccess?.();
  } else {
    action.meta?.onError?.();
  }
}

export function* setEbsSiteRestore() {
  yield takeLatest([Actions.API_EBS_RESTORE_BACKUP], postEbsSiteRestore);
}

function* postEbsSiteRestore(action) {
  // meta callbacks are invoked by the service (onSuccess gets the 202 body)
  const result = yield call(apiEbsSiteRestore, action);
  return result;
}

export function* setEbsCreateBackup() {
  yield takeLatest([Actions.API_EBS_CREATE_BACKUP], postEbsCreateBackup);
}

function* postEbsCreateBackup(action) {
  const result = yield call(apiEbsCreateBackup, action);
  return result;
}

export function* setSiteDownload() {
  yield takeLatest([Actions.API_SITE_DOWNLOAD_BACKUP], postSiteBackupDownload);
}

function* postSiteBackupDownload(action) {
  const result = yield call(apiSiteBackupDownload, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess(result.data);
  } else {
    action.meta?.onError();
  }
  return result;
}

export function* apiSiteImages() {
  yield takeLatest([Actions.API_SITE_IMAGE], siteimage);
}

function* siteimage(action) {
  const result = yield call(apiGetSiteImages, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    // Toast("Api failed", "Failed to upload file", "danger");
    action.meta?.onError();
  }
}

export function* apiDeleteImages() {
  yield takeLatest([Actions.API_REMOVE_SITE_IMAGE], deleteimage);
}

function* deleteimage(action) {
  const result = yield call(apiDelImage, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    // Toast("Api failed", "Failed to upload file", "danger");
    action.meta?.onError();
  }
}

export function* getS3PresignedUrl() {
  yield takeLatest([Actions.API_S3_SIGNED_URL], S3PresignedUrl);
}

function* S3PresignedUrl(action) {
  const result = yield call(fetchS3PresignedUrl, action);
  return result;
}

export function* cacheInvalidation() {
  yield takeLatest([Actions.API_CACHE_INVALIDATION], cacheInvalidationApi);
}

function* cacheInvalidationApi(action) {
  const result = yield call(apiCacheInvalidation, action);
  if (result.isApiSuccessful) {
    action.meta.onSuccess();
  } else {
    action.meta.onError();
  }
}

export function* downloadSelectedSiteFile() {
  yield takeLatest([Actions.API_DOWNLOAD_SITE_FILE], downloadSiteFiles);
}

function* downloadSiteFiles(action) {
  const result = yield call(apiDownloadSiteFiles, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess(result.data);
  } else {
    action.meta?.onError();
  }
  return result;
}

export function* downloadSelectedSiteFolder() {
  yield takeLatest([Actions.API_DOWNLOAD_SITE_FOLDER], downloadSiteFolder);
}

function* downloadSiteFolder(action) {
  const result = yield call(apiDownloadSiteFolder, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess(result.data);
  } else {
    action.meta?.onError();
  }
  return result;
}

export function* tagName() {
  yield takeLatest([Actions.API_GET_TAG_NAME], tagNames);
}

function* tagNames(action) {
  const result = yield call(apiTagName, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    // Toast("Api failed", "Failed to upload file", "danger");
    action.meta?.onError();
  }
}

export function* getLabel() {
  yield takeLatest([Actions.API_GET_LABEL], getLabelName);
}

function* getLabelName(action) {
  const result = yield call(apilabelName, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    // Toast("Api failed", "Failed to upload file", "danger");
    action.meta?.onError();
  }
}

export function* deleteDomain() {
  yield takeLatest([Actions.API_DELETE_DOMAIN], removeDomain);
}

// apiRemoveDomain calls meta.onSuccess/onError itself (once)
function* removeDomain(action) {
  return yield call(apiRemoveDomain, action);
}

export function* setSitesDomainSslStatus() {
  yield takeLatest(
    [Actions.API_SITES_DOMAIN_SSL_STATUS],
    putSitesDomainSslStatus
  );
}

function* putSitesDomainSslStatus(action) {
  const result = yield call(apiSitesDomainSslStatus, action);
  return result;
}

export function* uploadFile() {
  yield takeLatest([Actions.API_UPLOAD_FILE], uploadObject);
}

function* uploadObject(action) {
  const result = yield call(apiUploadObject, action.data);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* deleteSftpUser() {
  yield takeLatest([Actions.API_DELETE_SFTP_USER], sftpUserDelete);
}

function* sftpUserDelete(action) {
  const result = yield call(apiDeleteSftpUser, action);
  if (result.isApiSuccessful) {
  } else {
    action.meta?.onError();
  }
}

export function* makeTempDoaminLive() {
  yield takeLatest([Actions.API_MAKE_TEMP_DOMAIN_LIVE], makeTempDoaminLiveapi);
}

function* makeTempDoaminLiveapi(action) {
  const result = yield call(apiMakeTempDomainLive, action);
  if (result.isApiSuccessful) {
    action.meta.onSuccess();
  } else {
    action.meta.onError();
  }
  return result;
}

export function* getSslStatus() {
  yield takeLatest([Actions.API_DOMAIN_SSL_STATUS], fetchSslStatus);
}

function* fetchSslStatus(action) {
  const result = yield call(apiSslStatus, action);
  return result;
}

export function* apiWpVersionUpdate() {
  yield takeLatest([Actions.API_WP_VERSION_UPDATE], wpVersionUpdate);
}

function* wpVersionUpdate(action) {
  const result = yield call(apiWordpressVersionUpdate, action);
}

export function* getGraph() {
  yield takeLatest([Actions.API_GRAPH_DETAILS], graphDetails);
}

function* graphDetails(action) {
  const result = yield call(apiGraphDetails, action);
  if (result?.isApiSuccessful) {
    action.meta?.onSuccess?.();
  } else {
    action.meta?.onError?.();
  }
}

export function* siteOverview() {
  yield takeLatest([Actions.API_SITE_OVERVIEW], siteOverviewAPI);
}

function* siteOverviewAPI(action) {
  const result = yield call(apiSiteOverview, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* topSitesSagas() {
  yield takeLatest([Actions.API_TOP_SITES], topSites);
}

function* topSites(action) {
  const result = yield call(apiTopSites, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* sitesList() {
  yield takeLatest([Actions.API_SITES_LIST], getSitesList);
}

function* getSitesList(action) {
  const result = yield call(apiSitesList, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* createStaging() {
  yield takeLatest([Actions.API_CREATE_STAGING], createStagingEnvironment);
}

function* createStagingEnvironment(action) {
  const result = yield call(apiCreateStagingEnvironment, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError(result);
  }
}

export function* deleteStaging() {
  yield takeLatest([Actions.API_DELETE_STAGING], deleteStagingEnvironment);
}

function* deleteStagingEnvironment(action) {
  const result = yield call(apiDeleteStagingEnvironment, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* apiToggleStaging() {
  yield takeLatest([Actions.API_TOGGLE_STAGING], toggleStagingEnvironment);
}

function* toggleStagingEnvironment(action) {
  const result = yield call(apiStagingToggle, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* apiSubmitMigrateDetails() {
  yield takeLatest([Actions.API_SUBMIT_MIGRATE_DETAILS], migrateSiteDetails);
}

function* migrateSiteDetails(action) {
  const result = yield call(submitMigrateDetails, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    const errorMessage = result?.data?.response?.data?.errorMessage;
    action.meta?.onError(errorMessage);
  }
}

export function* apiStagingDomain() {
  yield takeLatest([Actions.API_STAGING_DOMAIN_LIST], stagingDomainList);
}

function* stagingDomainList(action) {
  const result = yield call(apiStagingDomainList, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* migrationProgress() {
  yield takeLatest([Actions.API_GET_MIGRATION_PROGRESS], migrationProgressApi);
}

function* migrationProgressApi(action) {
  const result = yield call(isMigrationProgress, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* apiStagingTimestamp() {
  yield takeLatest([Actions.API_STAGING_TIMESTAMP], stagingTimestamp);
}

function* stagingTimestamp(action) {
  const result = yield call(apiStagingRemainTs, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* apiCommand() {
  yield takeLatest([Actions.API_EXECUTE_COMMAND], commandApi);
}

function* commandApi(action) {
  const result = yield call(executeCommand, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* apiAutoLogin() {
  yield takeLatest([Actions.API_AUTO_LOGIN], autoLoginApi);
}

function* autoLoginApi(action) {
  const result = yield call(autoLogin, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* apiPlanOvergauge() {
  yield takeLatest([Actions.API_FETCH_PLAN_OVERGAUGE], planOvergauge);
}

function* planOvergauge(action) {
  const result = yield call(apiFetchPlanOvergauge, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* apiSslhandler() {
  yield takeLatest([Actions.API_SSL_HANDLER], sslhandler);
}

function* sslhandler(action) {
  const result = yield call(apiRoconSslhandler, action);
  if (result?.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* apiDownloadInstanceKeySaga() {
  yield takeLatest([Actions.API_DOWNLOAD_INSTANCE_KEY], downloadInstanceKey);
}

function* downloadInstanceKey(action) {
  const result = yield call(apiDownloadInstanceKey, action);
  if (result?.isApiSuccessful) {
    window.location.href = result.data;
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* apiGetInstancePasswordSaga() {
  yield takeLatest([Actions.API_GET_INSTANCE_PASSWORD], getInstancePassword);
}

function* getInstancePassword(action) {
  const result = yield call(apiGetLightSailPassword, action);
  if (result.isApiSuccessful) {
    yield put({
      type: Actions.SET_INSTANCE_PASSWORD,
      data: result.data,
    });
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* apiInstallDomainSaga() {
  yield takeLatest([Actions.API_INSTALL_INSTANCE_DOMAIN], installDomain);
}

// apiInstallDomain calls meta.onSuccess/onError itself (once)
function* installDomain(action) {
  return yield call(apiInstallDomain, action);
}

export function* restoreDedicatedSiteSaga() {
  yield takeLatest([Actions.API_RESTORE_DEDICATED_SITE], restoreDedicatedSite);
}

function* restoreDedicatedSite(action) {
  const result = yield call(apiDedicatedRestore, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* dedicatedOnDemandSaga() {
  yield takeLatest(
    [Actions.API_DEDICATED_ON_DEMAND_BACKUP],
    dedicatedOnDemandBackup
  );
}

function* dedicatedOnDemandBackup(action) {
  const result = yield call(apiDedicatedOnDemandBackup, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* dedicatedStorageSaga() {
  yield takeLatest([Actions.API_DEDICATED_STORAGE], dedicatedStorage);
}

function* dedicatedStorage(action) {
  const result = yield call(apiGetDedicatedStorage, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* dedicatedPhpCredsSaga() {
  yield takeLatest([Actions.API_GET_PHP_CREDS], dedicatedPhpCreds);
}

function* dedicatedPhpCreds(action) {
  const result = yield call(apidedicatedPhpCreds, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* checkDnsStatusSaga() {
  yield takeLatest([Actions.API_CHECK_DNS_STATUS], checkDnsStatus);
}

// apiCheckDnsStatus calls meta.onSuccess/onError itself (once); calling them here too made
// the v2 wizard send makeDomainPrimary twice
function* checkDnsStatus(action) {
  return yield call(apiCheckDnsStatus, action);
}
